import script from "./ErrorRender.vue?vue&type=script&lang=ts&setup=true"
export * from "./ErrorRender.vue?vue&type=script&lang=ts&setup=true"

import "./ErrorRender.vue?vue&type=style&index=0&id=89d6efb8&lang=scss"

const __exports__ = script;

export default __exports__